import { Box } from "@mui/system";

import { Button, Typography } from "@mui/joy";
import { Helmet } from "react-helmet";
import { Outlet, useParams } from "react-router-dom";
import { heightWithToolbar } from "../global";
import { VenuesDatagrid } from "../hooks/venuesDatagrid/venuesDatagrid";
import { useMyMember } from "../redux/member/memberHooks";
import { setFormOpen } from "../reducers/rhapsody";
import { useDispatch } from "react-redux";
import { usePro } from "../hooks/usePro/usePro";
import { proEnabled } from "../constants";

export default function Venues() {
  const param = useParams();
  const pro = usePro();
  const dispatch = useDispatch();
  if (param.venueID) return <Outlet />;

  return (
    <>
      <Box
        sx={{
          p: 2,
          display: "flex",
          gap: 2,
          flexDirection: "column",
          justifyContent: "stretch",
          margin: "auto",
          maxWidth: 1600,
          width: "100vw",
          position: "relative",
          flex: 1,
          height: heightWithToolbar,
        }}
      >
        <Helmet>
          <title>Rhapsody | Venues</title>
        </Helmet>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography level="h6">Venues</Typography>
          {proEnabled ? (
            <Button
              onClick={() =>
                dispatch(setFormOpen({ isOpen: true, formID: "venue" }))
              }
              size="sm"
              color="info"
            >
              + New Venue
            </Button>
          ) : (
            []
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            height: 0,
            minHeight: "auto",
          }}
        >
          <VenuesDatagrid />
        </Box>
      </Box>
    </>
  );
}
